const googleLang = {

}

const communicationLang = {
  senders: {
    type: {
      google: 'Google'
    }
  }
}

export default {
  google: googleLang,
  communication: communicationLang
}
